import { connect } from "react-redux";
import { bindActionCreators } from "redux";
import actionCreators from "../../actionCreators/index.js";
import LeaseAccordion from "./leaseAccordion";

function mapStateToProps(state) {
  return {
    transactions: state.transactions,
    bids: state.bids,
    paymentType: state.paymentType,
    errorFields: state.onSubmitDetails.errorFields,
    errorFlag: state.onSubmitDetails.errorFlag,
    actionType: state.actionType,
    texts :state.translatedTexts
  };
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators(actionCreators, dispatch);
}

export default connect(mapStateToProps, mapDispatchToProps)(LeaseAccordion);
